<template>
  <section class="news_outer">
    <div class="container">
      <div class="news_container">
        <h2>
          <slot name="title">Акции и скидки каждый день</slot>
        </h2>
        <div class="news_card_wrap flx" style="justify-content: start;">
          <a :href="item.link" class="card flx" v-for="(item,index) in stocks" :key="index">
            <div class="img_wrap">
              <img :src="item.img_url" alt="news">
              <span class="name">{{ item.name }}</span>
              <span class="discount to"><span>-</span>{{ item.discount }} {{ item.discount_type }}</span>
            </div>
            <div class="description_container flx">
              <div class="flx">
                <span class="qty_days orange">{{ item.time_left }}</span>
                <span class="text">до конца акции</span>
              </div>
              <p>{{ item.text }}</p>
            </div>
          </a>
        </div>
        <div style="margin-top: 20px">
          <router-link class="link stock-link" to="/stocks"> Смотреть все акции</router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'LastNews',
  computed: {
    ...mapState('stock', ['stocks'])
  },
  methods: {
    ...mapActions('stock', ['getStocks'])
  },
  created () {
    this.getStocks()
  }
}
</script>

<style scoped>
.link {
  padding: 10px;
  background: orange;
  color: white;
  margin: 20px;
  font-size: 16px;
}
</style>
